<template>
  <a-card :bordered="false">
    <div class="x-tool">
      <a-button type="primary" icon="plus" @click="add">新增顶级菜单</a-button>
    </div>

    <div style="min-height:580px">
      <a-tree
        :tree-data="treeData"
      >
        <template slot="custom" slot-scope="item">
          <div ref="treeNode" class="x-tree-node" @mouseenter="enter(item.key)" @mouseleave="leave(item.key)">
            <div class="info">
              <a-icon :type="item.children ? 'folder' : 'file'" class="icon" />
              <span>{{ item.title }}</span>
            </div>
            <div :id="'opt-' + item.key" style="display:none; margin:0">
              <template v-if="item.level == 1 || item.level == 2">
                <a @click="add({pid:item.key, parentName:item.title})">添加子功能</a>
                <a-divider type="vertical" />
              </template>
              <a @click="update(item.key)">修改</a>
              <a-divider type="vertical" />
              <a @click="del(item.key)">删除</a>
            </div>
          </div>
        </template>
      </a-tree>
    </div>

    <func-form-modal
        ref="funcForm"
        :visible="formVisible"
        :loading="formLoading"
        :model="formModel"
        @cancel="formCancel"
        @ok="formOk"
    />
  </a-card>
</template>

<script>
import FuncFormModal from './FuncForm';
import { funcAdd, funcUpdate, funcDelete, funcTree, funcItem } from "@/api/system/func";

export default {
  components: {
    FuncFormModal
  },
  data() {
    return {
      treeData: [],
      formVisible: false,
      formLoading: false,
      formModel: null,
    }
  },
  created() {
    this.fetchTreeData();
  },
  methods: {
    fetchTreeData() {
      return funcTree().then(res => {
        this.treeData = res.data;
      });
    },
    add(parent) {
      this.formModel = parent ? { ...parent } : { pid: 0, parentName: 'root' };
      this.formVisible = true;
    },
    update(key) {
      funcItem(key).then(res => {
        this.formModel = { ...res.data };
        this.formVisible = true
      })
    },
    del(key) {
      funcDelete(key).then(() => {
        this.fetchTreeData();
        this.$message.success('删除功能成功')
      })
    },
    enter(key) {
      document.querySelector('#opt-' + key).style.display = "block";
    },
    leave(key) {
      document.querySelector('#opt-' + key).style.display = "none";
    },
    formOk() {
      const funcForm = this.$refs.funcForm;
      if (!funcForm || !funcForm.$refs.adminForm) return;
      funcForm.$refs.adminForm.validate((valid) => {
        if (!valid) return;
        const values = { ...funcForm.form };
        this.formLoading = true;
        if (values.id > 0) {
          funcUpdate(values).then(() => {
            this.formAfter('修改功能成功');
          }).catch(() => { this.formLoading = false; });
        } else {
          funcAdd(values).then(() => {
            this.formAfter('添加功能成功');
          }).catch(() => { this.formLoading = false; });
        }
      });
    },
    formCancel() {
      this.formVisible = false;
      this.formModel = null;
      if (this.$refs.funcForm && this.$refs.funcForm.initForm) {
        this.$refs.funcForm.initForm();
      }
    },
    formAfter(message){
      this.formVisible = false;
      this.formLoading = false;
      if (this.$refs.funcForm && this.$refs.funcForm.initForm) {
        this.$refs.funcForm.initForm();
      }
      this.fetchTreeData();
      this.$message.success(message);
    }
  }
}
</script>

<style lang="less" scoped>
.x-tree-node {
  display: flex;
  justify-content: flex-start;
  width: 600px;
  .info {
    margin-right: 20px;

    .icon {
      margin-right: 8px;
    }
  }
}
</style>